import { createContext, useContext, useState, useEffect } from "react";

const FullscreenContext = createContext();

export const FullscreenContextProvider = ({ children }) => {
    const [fullscreenCard, setFullscreenCard] = useState(null);

    const openFullscreen = (card) => {
        setFullscreenCard(card);
    };

    const closeFullscreen = () => {
        setFullscreenCard(null);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                closeFullscreen();
            }
        };

        if (fullscreenCard) {
            window.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [fullscreenCard]);

    return (
        <FullscreenContext.Provider
            value={{
                isFullscreen: !!fullscreenCard,
                fullscreenCard,
                openFullscreen,
                closeFullscreen,
            }}
        >
            {children}
        </FullscreenContext.Provider>
    );
};

export const useFullscreen = () => useContext(FullscreenContext);
